import { ErrorCode } from '@operations/utils/ErrorCode/error-code-enum'
import { useTranslate } from '@tolgee/react'
import { getAllErrorDescriptions } from '@tom-ui/utils'

export const useShiftMessageHandler = () => {
  const { t } = useTranslate()

  const getSuccessMessage = () => {
    return t('Success', 'Success')
  }

  const getExceptionMessage = (error: any) => {
    const errorDescriptions = getAllErrorDescriptions(error)

    const errors: string[] = []

    errorDescriptions.forEach(errorDescription => {
      if (errorDescription.code === ErrorCode.EntityNotFound) {
        errors.push(
          t('entityNotFound', '{entity} with Id {id} not found', {
            entity: errorDescription.payload?.name,
            id: errorDescription.payload?.id,
          }),
        )
      } else if (errorDescription.code === ErrorCode.ShiftTimeConflict) {
        errors.push(
          t(
            'shiftTimeConflictExitingShifts',
            'The shift {name} has a time conflict with existing shifts.',
            {
              name: errorDescription.payload?.name,
            },
          ),
        )
      }
    })

    if (errors.length > 0) return errors.join('\n')

    return error?.response?.data?.detail ?? t('somethingWentWrong', 'Something went wrong')
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
  }
}
